import React from 'react';
import PropTypes from 'prop-types';

// Form Template
import FormTemplate from '../common/Components/FormTemplate';

//  Form Steps
import VoucherProgram from './Steps/VoucherProgram';
import ReviewProgram from '../ReviewProgram';

// constants
import { VOUCHER } from '../common/Components/constants';

function VoucherProgramForm({ planData, planDataFlag }) {
  return (
    <FormTemplate>
      {/* Add form of each step here and form template will handle the rest */}
      {/* Step is mandatory, step starts from 1 */}
      {/* add display name if you want to show it in header */}
      <VoucherProgram
        step={1}
        planData={planData}
        planDataFlag={planDataFlag}
      />
      <ReviewProgram step={2} program={VOUCHER} />
    </FormTemplate>
  );
}

VoucherProgramForm.propTypes = {
  planData: PropTypes.objectOf(PropTypes.any),
  planDataFlag: PropTypes.bool,
};

VoucherProgramForm.defaultProps = {
  planData: {},
  planDataFlag: false,
};

export default VoucherProgramForm;
